import { Expose } from 'class-transformer'

export class CoinConditionType {
  @Expose() id: number

  @Expose() name: string
}
